import { TASK_TEMPLATES_TAB_NAME, SHIFT_TASKS_TAB_NAME, ROUTES_DICTIONARY } from './constants';

export default class ShiftTasksFlowCtrl {
  constructor(AccountService, SubscriptionUtils, ShiftTasksService, ShiftTasksTabsService, $state) {
    'ngInject';

    Object.assign(this, {
      AccountService,
      SubscriptionUtils,
      ShiftTasksService,
      ShiftTasksTabsService,
      $state,
    });

    this.shiftTasksTabs = ShiftTasksTabsService.tabs;
    this.shouldDisplaySubNavigation = ShiftTasksTabsService.shouldDisplayTabs();
  }

  get currentTabName() {
    return this.ShiftTasksTabsService.currentTab.value;
  }

  selectTab(value) {
    this.ShiftTasksTabsService.setTabByValue(value);
    this.$state.go(ROUTES_DICTIONARY[value] || 'tasks');
  }

  get isTaskTemplatesTabVisible() {
    return this.currentTabName === TASK_TEMPLATES_TAB_NAME;
  }

  get isShiftTasksTabVisible() {
    return this.currentTabName === SHIFT_TASKS_TAB_NAME;
  }
}
